<template>
  <div
    ref="sliderContainer"
    class="nav-cat-scroll slider"
    @mouseup="handleMouseUp"
    @mousedown="handleMouseDown"
    @mouseleave="handleMouseUp"
    @mousemove="handleMouseMove"
  >
    <div class="nav-cat-wrap" :style="{ transform: `translateX(${currentTranslateX}px)` }">
      <div class="nav-cat">
        <span
          v-for="({ id, identity, name }, index) in filteredCategories"
          :key="id"
          class="nav-cat-item"
          :data-index="index"
          :class="{
            'is-active': routeParams.includes(identityByLowercase(identity)),
            'is-no-icon': !gameCategoriesObj[identityByLowercase(identity)]?.icon,
          }"
          @click="emit('clickCategory', identity, isMoved)"
        >
          <atomic-icon :id="gameCategoriesObj[identityByLowercase(identity)]?.icon" />
          <span>{{ gameCategoriesObj[identityByLowercase(identity)]?.label || name }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { ICollection } from '~/skeleton/core/types';

  const emit = defineEmits(['clickCategory']);

  const { gameCategoriesObj } = useGlobalStore();
  const filteredCategories = ref<ICollection[]>([]);
  const sliderContainer = ref(null);
  const route = useRoute();
  const routeParams = route.params.params || [];

  const { currentTranslateX, handleMouseDown, handleMouseMove, handleMouseUp, isMoved } = useSlider({
    sliderContainer,
  });

  const identityByLowercase = (identity: string): string => {
    return identity.toLowerCase()
  };

  watch(isMoved, (newValue) => {
    if (newValue) {
      setTimeout(() => {
        isMoved.value = false;
      }, 0);
    }
  });

  onMounted(async () => {
    const { getCollectionsList } = useGamesStore();
    const gameCollections = await getCollectionsList();
    filteredCategories.value = gameCollections.filter((collection) => !collection.isHidden);
    await nextTick();
  });
</script>

<style src="~/assets/styles/components/slider/nav/cat.scss" lang="scss" />
